import { connect } from '@formily/react-schema-renderer';
import { Transfer as AntdTransfer } from 'antd';
import { mapStyledProps } from '../shared';
export var Transfer = connect({
    getProps: mapStyledProps,
    valueName: 'targetKeys'
})(AntdTransfer);
export default Transfer;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@formily/antd-components/esm/transfer/index.js
// module id = 1041
// module chunks = 0